<template>
  <div class="flex flex-col justify-between min-h-screen px-6 pb-6 bg-white">
    <div class="flex items-center justify-between py-6 md:px-6">
      <div>
        <slot name="left" />
      </div>

      <div class="px-4 text-center md:px-6 lg:px-8">
        <slot name="center" />
      </div>

      <div>
        <slot name="right" />
      </div>
    </div>

    <div
      :class="!noPadding ? 'px-6 py-10 md:py-16' : ''"
      class="relative flex-auto w-full mx-auto overflow-hidden bg-gray-100 bg-hexagon rounded-xl md:rounded-xxl"
      style="max-width: 1440px"
    >
      <transition appear name="fade" mode="out-in">
        <div key="frameSlot">
          <slot />
        </div>
      </transition>
    </div>

    <toast position="top-center" />

    <cookie-accept/>
  </div>
</template>

<script>
import CookieAccept from "@/components/CookieAccept";

export default {
  components: {
    CookieAccept
  },
  props: {
    noPadding: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      //
    }
  },

  methods: {
    //
  }
}
</script>
